import React from "react";

const Logo = ({ image, addedStyles }) => {
  return (
    <div className="img-responsive text-center">
      <img
        src={image}
        alt="manpower-logo"
        style={{
          width: "200px",
          ...addedStyles,
        }}
      />
    </div>
  );
};

export default Logo;
